import { Button, Col, Row, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout, ModalWarehouses } from "../../../shared/components";
import { WrapperWarehouses } from "./styled";
import { TableWarehouses } from "./TableWarehouses";
import React from "react";

const { Title } = Typography;

export const Warehouses = () => {
  const [openModalCreateWarehouses, setOpenModalCreateWarehouses] =
    React.useState<boolean>(false);
  const [openModalEditWarehouses, setOpenModalEditWarehouses] =
    React.useState<boolean>(false);
  React.useState<boolean>(false);
  const [warehouseId, setWarehouseId] = React.useState<number>();

  return (
    <AdminMenuLayout pageDescription="Warehouses" title="Warehouses">
      <WrapperWarehouses>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Title>Bodegas</Title>
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={() => setOpenModalCreateWarehouses(true)}
            >
              Agregar nueva bodega
            </Button>
          </Col>
        </Row>
        <TableWarehouses
          setWarehouseId={setWarehouseId}
          setOpenModalEdit={setOpenModalEditWarehouses}
        />

        <ModalWarehouses
          openModalCreate={openModalCreateWarehouses}
          openModalEdit={openModalEditWarehouses}
          setOpenModalCreate={setOpenModalCreateWarehouses}
          setOpenModalEdit={setOpenModalEditWarehouses}
          warehouseId={warehouseId!}
        />
      </WrapperWarehouses>
    </AdminMenuLayout>
  );
};
